import React from 'react';

interface EntriesInfoProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
}

const EntriesInfo: React.FC<EntriesInfoProps> = ({ currentPage, pageSize, totalItems }) => {
  const start = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  return (
    <span className="text-[12px] text-black dark:text-white">
      Showing {start} to {end} of {totalItems} Entries
    </span>
  );
};

export default EntriesInfo;
